import {
  WHEEL_MAINTENANCE_ALL,
  WHEEL_MAINTENANCE_GET,
  WHEEL_MAINTENANCE_POST,
  WHEEL_MAINTENANCE_PUT,
  WHEEL_MAINTENANCE_DELETE,
  WHEEL_MAINTENANCE_LOADING,
  WHEEL_MAINTENANCE_ERROR,
  WHEEL_MAINTENANCE_RESET,
} from '../../actions/types';

const initialState = {
  wheel: null,
  isLoading: true,
  isCompleted: false,
};
// eslint-disable-next-line func-names
export default function (state = initialState, action) {
  switch (action.type) {
    case WHEEL_MAINTENANCE_LOADING:
      return { isLoading: true, isCompleted: false };
    case WHEEL_MAINTENANCE_ERROR:
      return { isLoading: false, isCompleted: false };
    case WHEEL_MAINTENANCE_ALL:
      return {
        ...action.payload,
        isLoading: false,
        isCompleted: true,
      };
    case WHEEL_MAINTENANCE_GET:
      return {
        ...action.payload,
        isLoading: false,
        isCompleted: true,
      };
    case WHEEL_MAINTENANCE_POST:
      return { isLoading: false, isCompleted: true };
    case WHEEL_MAINTENANCE_PUT:
      return { isLoading: false, isCompleted: true };
    case WHEEL_MAINTENANCE_DELETE:
      return { isLoading: false, isCompleted: true };
    default:
      return state;
  }
}
